// extracted by mini-css-extract-plugin
module.exports = {"border":"115px","borderMobile":"0","small":"navbar-component-module--small--3VECx","item":"navbar-component-module--item--1Lwdr","navbar":"navbar-component-module--navbar--1VN3i"};